import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from "@material-ui/core";
import React from "react";
import { l } from "../functions";
import Icon from "./../components/Icons";

const AdminSaveDialog = ({
  show = false,
  onCancel = () => {},
  onConfirm = () => {},
  onClose = () => {},
}) => {
  if (show)
    return (
      <Dialog
        open={show}
        onClose={() => {
          onClose();
        }}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">
          {l("Your modifications will be lost")}
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            {l(
              "By going back to websites. You are going to loose unsave modification. Do you want to save?"
            )}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <button
            onClick={() => {
              onCancel();
            }}
          >
            <span>{l("Do not save")}</span>
          </button>
          <button
            onClick={() => {
              onConfirm();
            }}
          >
            <span>{l("Save")}</span>
          </button>
        </DialogActions>
      </Dialog>
    );
  else {
    return null;
  }
};

export default AdminSaveDialog;
